import { createContext } from "react";
import type { FreshnessMeta, SourceKind } from "@/lib/analytics/freshness";

/** What a v2 MetricCard reads for its chip, footer and source popover (ANL-E04-S09). */
export type MetricSource = {
  kind: SourceKind;
  // The response's meta; null when none came back, which the card renders as Error.
  meta: FreshnessMeta | null;
};

/**
 * Set by a tile frame (Product records, the agentic funnel) around the cards it renders, so the
 * cards inside read their source without each one passing it. No provider and no `source` prop:
 * the card renders exactly as it did before v2.
 */
export const MetricSourceContext = createContext<MetricSource | null>(null);
